import React, { useState, useEffect } from 'react'
import { Card, CardBody, Col } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { backendbaseUrl } from '../../../../../Utils/baseUrl';
import axiosInstance from '../../../../../Utils/axiosInstance';
import TrailRequestCardHeader from './TrailRequestCardHeader';
import FilterComponent from '../../../../Miscellaneous/SupportTicket/TicketTable/FilterComponent';
import { TrailRequestcolumns } from '../datas/TrailRequestDataConfiguration';
import { CustomExpandableComponent } from '../datas/TrailRequestExpandables';

export default function TrailRequestLists() {
    const [filterText, setFilterText] = useState('');
    const [data, setData] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // State for Editing
    const [editRow, setEditRow] = useState<number | null>(null);
    const [editedValues, setEditedValues] = useState<any>({});

    useEffect(() => {
        let url = `${backendbaseUrl}/company/company-trail/list/?page=${currentPage}`;
        if (filterText) url += `&search=${filterText}`;
        if (rowsPerPage) url += `&page_size=${rowsPerPage}`;

        axiosInstance.get(url)
            .then((response) => {
                setData(response.data.results);
                setTotalPages(Math.ceil(response.data.count / rowsPerPage));
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [currentPage, filterText, rowsPerPage]);

    const handlePageChange = (page: number) => setCurrentPage(page);
    const handleRowsPerPageChange = (newPerPage: number) => {
        setRowsPerPage(newPerPage);
        setCurrentPage(1);
    };

    // When double-clicking, enable editing for the entire row
    const handleDoubleClick = (row: any) => {
        setEditRow(row.id);
        setEditedValues({
            first_name: row.first_name,
            email: row.email,
            company_name: row.company_name
        });
    };

    // Handle input changes for edited fields
    const handleChange = (rowId: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setEditedValues((prev: { [key: string]: string }) => ({ ...prev, [name]: value }));

    };

    // Handle submitting changes
    const handleSubmit = (rowId: number) => {
        // Find the row and update the data
        setData((prevData) =>
            prevData.map((row) =>
                row.id === rowId ? { ...row, ...editedValues } : row
            )
        );

        // Send updated data to backend
        axiosInstance.put(`${backendbaseUrl}/company/company-trail/${rowId}/`, editedValues)
            .then(() => {
                console.log("Updated successfully!");
            })
            .catch((error) => {
                console.error("Error updating:", error);
            });

        // Exit edit mode
        setEditRow(null);
    };

    return (
        <div>
            <Col sm={12}>
                <Card>
                    <TrailRequestCardHeader headClass='pb-0 card-no-border' title={"New Trail Requests "} subTitle={"New Trail requests will appear here"} />
                    <CardBody>
                        <FilterComponent
                            onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                            filterText={filterText}
                        />
                        <DataTable
                            className="custom-scrollbar"
                            data={data}
                            columns={TrailRequestcolumns(editRow, editedValues, handleDoubleClick, handleChange, handleSubmit)}
                            expandableRowsComponent={CustomExpandableComponent}
                            pagination
                            paginationServer
                            paginationTotalRows={totalPages * rowsPerPage}
                            paginationDefaultPage={currentPage}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handleRowsPerPageChange}
                            expandableRows={true}
                            striped
                            highlightOnHover
                            paginationRowsPerPageOptions={[10, 25, 50]}
                        />
                    </CardBody>
                </Card>
            </Col>
        </div>
    );
}
